import CryptoJS from 'crypto-js';
import axios from "axios";

const decryptionRequired = process.env.REACT_APP_DECRYPTION_REQUIRED;

export const decryptResponse = (encryptedResponse) => {
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY);
    const ivBytes = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_IV_KEY);
    const decrypted = CryptoJS.AES.decrypt({ 
        ciphertext: CryptoJS.enc.Base64.parse(encryptedResponse) 
    }, key, { 
        iv: ivBytes, mode: CryptoJS.mode.CTR, padding: CryptoJS.pad.NoPadding
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

const apiService = {

    async get(url) {
        try {
            let result = await axios.get(url, { withCredentials: true });
            if (result?.data?.error) {
                return null;
            }
            let decryptedResponse = decryptionRequired == "true" ? JSON.parse(decryptResponse(result?.data)) : result?.data;
            return decryptedResponse;
        } catch (error) {
            console.log(error)
            if(error?.response?.data?.status === 500 || !error?.response?.data) {
                return null;
            }
            let decryptedResponse = decryptionRequired == "true" ? JSON.parse(decryptResponse(error?.response?.data)) : error?.response?.data;
            return decryptedResponse;
        }
    },

    async post(url, postData) {
        try {
            let result = await axios.post(url, postData);
            if (result?.data?.error) {
                return null;
            }
            let decryptedResponse = decryptionRequired == "true" ? JSON.parse(decryptResponse(result?.data)) : result?.data;
            return decryptedResponse;
        } catch (error) {
            console.log(error)
            if(error?.response?.data?.status === 500 || !error?.response?.data) {
                return null;
            }
            let decryptedResponse = decryptionRequired == "true" ? JSON.parse(decryptResponse(error?.response?.data)) : error?.response?.data;
            return decryptedResponse;
        }
    },

    async put(url, postData) {
        try {
            let result = await axios.put(url, postData);
            if (result?.data?.error) {
                return null;
            }
            let decryptedResponse = decryptionRequired == "true" ? JSON.parse(decryptResponse(result?.data)) : result?.data;
            return decryptedResponse;
        } catch (error) {
            console.log(error)
            if(error?.response?.data?.status === 500 || !error?.response?.data) {
                return null;
            }
            let decryptedResponse = decryptionRequired == "true" ? JSON.parse(decryptResponse(error?.response?.data)) : error?.response?.data;
            return decryptedResponse;
        }
    },

    async delete(url) {
        try {
            let result = await axios.delete(url);
            if (result?.data.error) {
                return null;
            }
            let decryptedResponse = decryptionRequired == "true" ? JSON.parse(decryptResponse(result?.data)) : result?.data;
            return decryptedResponse;
        } catch (error) {
            console.log(error)
            if(error?.response?.data?.status === 500 || !error?.response?.data) {
                return null;
            }
            let decryptedResponse = decryptionRequired == "true" ? JSON.parse(decryptResponse(error?.response?.data)) : error?.response?.data;
            return decryptedResponse;
        }
    },

};

export default apiService;